<template>
  <div id="app" v-if="$auth.ready()">
    <template v-if="pageLoaded">
      <action-alert :close-method="closeAlert" :type="alertType" icon="exclamation-circle"
                    :is-visible="alertMessage !== ''">
        {{alertMessage}}
      </action-alert>
      <LogoutPopup ref="popup"/>
      <ErrorTraceback v-if="error.display" :traceback="error.traceback"/>
      <header class="app-header navbar">
        <!--      <button @click.prevent="sidebarToggle($event)" class="navbar-toggler sidebar-toggler d-md-down-none h-100 b-r-1"-->
        <!--              type="button">-->
        <!--        <span class="navbar-toggler-icon"></span>-->
        <!--      </button>-->
        <ul class="navbar-nav ml-auto p-0" style="margin-right: 50px;">
          <li
              v-if="$auth.check()"
              class="nav-item">
            <div class="dropdown" :class="dropdownToggled ? 'show' : ''" @click="dropdownToggled = !dropdownToggled">
              <button class="btn btn-secondary dropdown-toggle" id="dropdownMenu3" type="button" data-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                <font-awesome-icon class="mr-2" icon="user"/>
                {{ $auth.user().screenname }}
              </button>
              <div class="dropdown-menu" :class="dropdownToggled ? 'show' : ''" x-placement="bottom-start"
                   style="">
                <div class="dropdown-menu-title">Profile settings</div>
                <template v-if="userPermissions.isAdmin || userPermissions.canModifyHelpUrl">
                  <h6 class="dropdown-header">Admin panel</h6>
                  <router-link
                      class="dropdown-item"
                      :to="{name: 'admin-panel'}">
                    Site settings
                  </router-link>
                </template>
                <h6 class="dropdown-header">User panel</h6>
                <template v-if="userPermissions.isAdmin || userPermissions.canModifyUsers">
                  <router-link
                      class="dropdown-item"
                      :to="{name: 'user-list'}">
                    User list
                  </router-link>
                </template>
                <a class="dropdown-item" v-if="url"
                   :href="url.includes('http') ? url : 'https://' + url" target="_blank">
                  Help
                </a>
                <a class="dropdown-item dropdown-item-alt" @click.prevent="logout()" style="cursor: pointer">Log out</a>
              </div>
            </div>
          </li>
          <li
              v-if="!$auth.check()"
              class="nav-item">
            <router-link
                class="nav-link"
                :to="{name: 'login'}">
              <font-awesome-icon icon="user"/>
              Login
            </router-link>
          </li>
        </ul>
      </header>
      <div class="sidebar">
        <button @click.prevent="mobileSidebarToggle($event)"
                class="navbar-toggler mobile-sidebar-toggler d-lg-none mr-auto" type="button">
          <span class="navbar-toggler-icon"></span>
        </button>
        <button @click.prevent="sidebarToggle($event)" class="sidebar-minimizer brand-minimizer" type="button">
          <span class="tool-title">IRIS</span>
          <span class="navbar-toggler-icon"></span>
        </button>
        <nav class="sidebar-nav">
          <ul class="nav">
            <li class="nav-item">
              <router-link :to="{name: 'home'}" class="nav-link">
                <font-awesome-icon icon="home" class="nav-link-icon"/>
                <div class="nav-link-text ml-2"><span>Home</span></div>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'search'}" class="nav-link">
                <font-awesome-icon icon="search" class="nav-link-icon"/>
                <div class="nav-link-text ml-2"><span>Search for Study</span></div>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'topworst'}" class="nav-link">
                <font-awesome-icon icon="trophy" class="nav-link-icon"/>
                <div class="nav-link-text ml-2"><span>Best/Worst Testers</span></div>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'attributes'}" class="nav-link">
                <font-awesome-icon icon="share-alt" class="nav-link-icon"/>
                <div class="nav-link-text ml-2"><span>Fragrance Profile</span></div>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'category-profile'}" class="nav-link">
                <font-awesome-icon icon="arrows-alt" class="nav-link-icon"/>
                <div class="nav-link-text ml-2"><span>Category Profile</span></div>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{name: 'group-comparison'}" class="nav-link">
                <font-awesome-icon icon="address-card" class="nav-link-icon"/>
                <div class="nav-link-text ml-2"><span>Group Comparison</span></div>
              </router-link>
            </li>
            <template v-if="userPermissions.isAdmin || userPermissions.canAccessAnalytics">
              <li class="nav-item">
                <router-link :to="{name: 'analytics'}" class="nav-link">
                  <font-awesome-icon icon="vial" class="nav-link-icon"/>
                  <div class="nav-link-text ml-2"><span>Advanced Analytics</span></div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{name: 'cics'}" class="nav-link">
                  <font-awesome-icon icon="user" class="nav-link-icon"/>
                  <div class="nav-link-text ml-2"><span>CICS</span></div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{name: 'studies-upload'}" class="nav-link">
                  <font-awesome-icon icon="cloud-upload-alt" class="nav-link-icon"/>
                  <div class="nav-link-text ml-2"><span>Studies Upload</span></div>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{name: 'statistics-generator'}" class="nav-link">
                  <font-awesome-icon icon="chart-bar" class="nav-link-icon"/>
                  <div class="nav-link-text ml-2"><span>Statistics Generator</span></div>
                </router-link>
              </li>
            </template>
          </ul>
        </nav>
        <div class="sidebar-logo">
          <img :src="logo"/>
        </div>
      </div>
      <div class="app-body">
        <!-- Main content -->
        <main class="main">
          <Loader :class="{'global-loading': isSidebarToggled}" :show="loading" :fixed="true"/>
          <router-view/>
        </main>
        <ApplicationInfoBox ref="info"/>
      </div>
      <footer class="app-footer">
        <span>Symrise © {{ new Date().getFullYear() }}</span>
        <font-awesome-icon style="cursor: pointer; margin-left: auto; font-size: 18px;" color="#3C3857" icon="info"
                           @click="$refs.info.openBox()"/>
      </footer>
    </template>
    <template v-else>
      <Loader class="global-loading" :show="true" :fixed="true" :initialLoad="true"/>
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ActionAlert from '../components/shared/ActionAlert'
import generalGetters from '../store/modules/general/getterTypes'
import generalActions from '../store/modules/general/actionTypes'
import studiesGetters from '../store/modules/studies/getterTypes'
import studiesActions from '../store/modules/studies/actionTypes'
import logo from '../assets/images/logos/symrise-logo-white.svg'
import bg from '../assets/images/backgrounds/bg.svg'
import iris from '../assets/images/backgrounds/iris.svg'
import ApplicationInfoBox from '../components/shared/ApplicationInfoBox'
import ErrorTraceback from '../components/shared/ErrorTraceback'
import LogoutPopup from '../components/shared/LogoutPopup'
import Loader from '../components/shared/Loader'

export default {
  name: 'layout',
  components: { Loader, LogoutPopup, ErrorTraceback, ApplicationInfoBox, ActionAlert },
  data () {
    return {
      pageLoaded: false,
      dropdownToggled: false,
      url: '',
      vueVersion: process.env.VUE_APP_COMMIT_TAG || 'No commit set',
      logo,
      iris,
      bg
    }
  },
  computed: {
    ...mapGetters({
      apiVersion: generalGetters.GET_API_VERSION,
      userPermissions: generalGetters.GET_PERMISSIONS,
      loading: generalGetters.GET_LOADING,
      error: generalGetters.GET_ERROR,
      isSidebarToggled: generalGetters.GET_SIDEBAR_STATE,
      isMobileSidebarToggled: generalGetters.GET_MOBILE_SIDEBAR_STATE,
      totalStudiesCount: studiesGetters.GET_STUDY_COUNT,
      alertMessage: generalGetters.GET_ALERT_MESSAGE,
      alertType: generalGetters.GET_ALERT_TYPE
    })
  },
  methods: {
    ...mapActions({
      setPermissions: generalActions.SET_PERMISSIONS,
      getStudiesCount: studiesActions.FETCH_STUDIES_COUNT,
      setSidebarState: generalActions.TOGGLE_SIDEBAR,
      getFieldsDefinition: generalActions.FETCH_FIELD_DEFINITIONS,
      getUrl: generalActions.GET_HELP_URL,
      setMobileSidebarState: generalActions.TOGGLE_MOBILE_SIDEBAR,
      getApiVersion: generalActions.FETCH_API_VERSION,
      setAlert: generalActions.SET_GLOBAL_ALERT,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    logout () {
      this.$refs.popup.showPopup()
    },
    closeAlert () {
      this.setAlert({ message: '', type: '' })
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
      this.setSidebarState(!this.isSidebarToggled)
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
      this.setMobileSidebarState(!this.isMobileSidebarToggled)
    }
  },
  created () {
    this.getApiVersion()
  },
  async mounted () {
    await this.getFieldsDefinition()
    await this.setPermissions(this.$auth.user())
    const responseUrl = await this.getUrl()
    // For now don't match against a regex expression. Uncomment and change to a desired regex if such match is needed
    // const re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
    // if (re.test(responseUrl)) {
    //   this.url = responseUrl
    // }
    this.url = responseUrl
    this.pageLoaded = true
  }
}
</script>

<style lang="scss">
@import "../assets/scss/variables";

.nav {
  text-align: left;

  a {
    font-weight: bold;
    color: $sidebar-link !important;
    text-align: left;

    &.router-link-exact-active {
      color: $sidebar-selected-color !important;
      background-color: $sidebar-selected !important;
      border-left: 5px solid $sidebar-selected-color;
    }
  }
}

.img-container {
  overflow-y: hidden;
  display: flex;
  align-items: center;
  width: 100%;
  height: 54px;
}

.global-alert {
  position: fixed !important;
  top: 60px;
  right: 20px;
  min-width: 250px;
  z-index: 10;
}

.vld-icon {
  transition: margin-left 0.2s linear;
}

.global-loading {
  .vld-icon {
    margin-left: 250px;
  }
}

.dwn-button {
  cursor: pointer;
  width: 45px;
  height: 45px;
  margin-right: 15px;
}

.nav-item {
  margin: 9px 0
}

.app-header {
  right: 0;
  left: 0;
  top: 0;
  width: unset !important;
  background-color: $header-background !important;
  transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, flex 0.25s;
  border-bottom: 0 !important;
}

.header-fixed .app-header {
  width: auto !important;
}

.dropdown-menu {
  width: 215px;
  position: absolute !important;
  will-change: transform;
  top: 8px !important;
  left: -68px !important;
  transform: translate3d(0px, 35px, 0px);
  border: 0 !important;

  &:after {
    bottom: 100%;
    left: 50%;
    border: 7px solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-bottom-color: white;
    margin-left: -7px;
  }

  .dropdown-menu-title {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $home-card;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 900;
    font-size: 17px;
    line-height: 12px;
    letter-spacing: 0;
    color: white;
    text-transform: uppercase;
  }

  .dropdown-item {
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 900;
    font-size: 13px;
    line-height: 17px;
    letter-spacing: 0;
    color: $navbar-dropdown-text !important;
  }

  .dropdown-item-alt {
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 900;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0;
    color: $active-link !important;
    border-top: 1px solid #e4e5e6;
  }

  .dropdown-header {
    font-family: 'Open Sans', sans-serif;
    font-size: 13px;
    line-height: 17px;
    text-transform: uppercase;
    background-color: $navbar-dropdown-background !important;
  }
}

.background-icon {
  position: fixed;
  bottom: -420px;
  right: 50px;
}

.sidebar-fixed .app-header {
  margin-left: 250px !important;
}

.sidebar-hidden .app-header {
  margin-left: 94px !important;
}

.sidebar-hidden .app-footer {
  margin-left: 94px !important;
}

.sidebar-hidden .sidebar {
  margin-left: -156px !important;

  .nav-link-text {
    width: 0;
  }

  .nav-link-icon {
    margin-left: 16px;
  }

  .nav-item {
    margin-left: 156px !important;
  }

  .sidebar-minimizer {
    &::before {
      transform: rotate(-180deg);
      margin-right: 25px;
    }
  }
}

.main {
  margin-left: 0 !important;
  height: 100%;
}

#app {
  display: flex !important;
  width: 100%;
  height: 100%;
}

.sidebar {
  position: relative !important;
  height: 100vh !important;
  background-color: $sidebar !important;

  .nav-link-text {
    width: 100%;
    margin-top: 3px;
    white-space: nowrap;
    overflow-x: hidden;
    transition: width 0.2s linear;
  }

  .nav-link-icon {
    margin-left: 0.5rem;
    transition: margin-left 0.2s linear;
    width: 24px;
    height: 24px;
  }

  .nav-item {
    margin-left: 0 !important;
    transition: margin-left 0.2s linear, background 0.3s ease-in-out !important;

    .nav-link:hover {
      background-color: $sidebar-selected !important;
    }
  }
}

.nav-link {
  display: flex !important;
  align-items: center;
  padding: 0.95rem 1rem !important;
}

.app-body {
  position: relative;
  width: calc(100% - 250px);
  height: calc(100vh - 105px);
  overflow: auto;
  background-image: url("../assets/images/backgrounds/bg-repeat.svg");
  background-size: 150px 150px;
  background-repeat: repeat;
}

.tool-title {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 24px;
  margin-left: 20px;
  letter-spacing: 4.8px;
  color: $white;
  transition: color 0.15s ease-in-out;
  text-decoration: none;

  &:hover {
    color: $lavender
  }
}

.sidebar-logo {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $sidebar-logo-background;
}

.sidebar-hidden .sidebar-logo {
  padding-right: 94px;
}

.dropdown-toggle {
  color: white !important;
}

.sidebar-minimizer {
  width: 250px;
  flex: unset !important;
  height: 55px;
  margin-bottom: 9px;
  display: flex;
  align-items: center;
  background-color: $tool-title-background;
  transition: all 0.2s ease-in-out;

  .navbar-toggler-icon {
    margin-right: 10px;
    color: $white;
  }

  &::before {
    background-size: 16px !important;
  }

  border: 0;
}

.el-input__inner {
  border: 2px solid $pewter !important;
}

.el-select__caret {
  color: $pewter !important;
  font-weight: 900 !important;
}

.el-slider__runway {
  background-color: $home-card !important;
}

.el-slider__bar {
  background-color: $magento !important;
  z-index: 2;
}

.el-slider__button {
  border-color: $magento !important;
}

.el-scrollbar__view {
  padding: 0 !important;
}

.el-step__title {
  margin-top: 7px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400 !important;
  font-size: 13px !important;
  line-height: 20px !important;
  letter-spacing: 0;
  color: $charcoal;
  padding-left: 3px;

  &.is-success {
    color: $charcoal !important;
  }
}

.el-slider__marks-text {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: $charcoal;
}

.el-step__head {
  height: 38px;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400 !important;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0;
  color: $charcoal;

  .el-step__line {
    top: 18px !important;
    left: 44px !important;
    width: 78%;
    background-color: $pewter;
  }

  &.is-process {
    .el-step__icon {
      border: 2px solid $magento !important;
    }
  }

  &.is-success {
    .el-step__icon {
      border: 2px solid $magento !important;
      background-color: $magento;
    }

    .el-step__line {
      background-color: $magento !important;
      border-color: $magento !important;
    }

    .el-step__icon-inner {
      color: white !important;
      font-weight: bolder !important;
    }
  }

  .el-step__icon {
    border: 1px solid $charcoal !important;
    width: 38px;
    height: 38px;
  }
}

.el-radio-button__inner {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400 !important;
  padding: 2px 15px !important;
  height: 40px;
  font-size: 20px !important;
  line-height: 36px !important;
  @media screen and (min-width: $break-lg) {
    padding: 2px 15px !important;
    height: 40px;
    font-size: 20px !important;
    line-height: 36px !important;
  }
  @media screen and (min-width: $break-xl) {
    padding: 5px 20px !important;
    height: 48px;
    font-size: 24px !important;
    line-height: 40px !important;
  }
  @media screen and (min-width: $break-xxl) {
    padding: 5px 20px !important;
    height: 55px;
    font-size: 28px !important;
    line-height: 44px !important;
  }
  @media screen and (min-aspect-ratio: 2/1) and (max-height: 800px) {
    padding: 2px 20px !important;
    height: 40px;
    font-size: 22px !important;
    line-height: 36px !important;
  }
}

.el-radio-button {
  margin-bottom: 0 !important;

  .el-radio-button__inner {
    background-color: #F5F5F5;
    color: $dusty-blue;

    &:hover {
      color: $magento !important;
    }
  }

  &.is-active {
    .el-radio-button__inner {
      background-color: $dusty-blue !important;
      border-color: $dusty-blue !important;
      color: white;
      box-shadow: -1px 0 0 0 $dusty-blue !important;

      &:hover {
        color: white !important;
      }
    }
  }
}

.el-slider__stop {
  border-radius: 0 !important;
  width: 3px !important;
}

.bs-tooltip-bottom {
  .arrow {
    &::before {
      border-bottom-color: white !important;
    }
  }
}

.el-tooltip__popper {
  background-color: white !important;
  box-shadow: 0 6px 6px #00000029;
  letter-spacing: 0;
  color: #525252 !important;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  line-height: 19px;

  .popper__arrow {
    border-top-color: white !important;

    &::after {
      border-top-color: white !important;
    }

    &::before {
      border-top-color: white !important;
    }
  }
}

.el-select-group__title {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2;
}

.el-select-dropdown__item {
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400 !important;
  font-size: 16px !important;
  color: $grey-800 !important;
  letter-spacing: 0;

  &.selected {
    font-weight: 600 !important;
    background-color: $row-highlight !important;
  }

  &::after {
    color: $magento;
  }
}

.tooltip-inner {
  text-align: left;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 17px;
  background-color: white !important;
  color: $button-text !important;
  border-radius: 5px;
}

.arrow::before {
  border-top-color: white !important;
}

.el-select-dropdown__item.selected {
  &::after {
    font-size: 24px !important;
  }
}

.el-scrollbar {
  min-width: 350px;
  .el-select-dropdown__wrap.el-scrollbar__wrap {
    margin-right: 0 !important;
    margin-bottom: 0 !important;
  }
}

.el-scrollbar__bar.is-vertical {
  z-index: 2 !important;
}

button:disabled {
  background-color: $grey-700 !important;
  color: white !important;
}

.b-tooltip {
  z-index: 1070 !important;
}

.el-scrollbar__wrap {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}

.el-scrollbar__wrap::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
}

.bs-tooltip-right {
  left: 220px !important;
  .arrow {
    &::before {
      border-right-color: white !important;
      border-top-color: transparent !important;
    }
  }
}

/*.el-select {*/
/*  max-height: 40px;*/
/*  &__tags {*/
/*    height: 35px;*/
/*    padding: 2px 0;*/
/*    overflow-y: scroll;*/
/*  }*/
/*}*/

</style>
